import React from 'react';
import "./Nav.css";

export const Nav = ({ children }) =>
  <nav id="sidebar-wrapper">
    {children}
  </nav>;